<template>
  <div class="commentItem" :class="{ replyItem: mode == 'reply' }">
    <el-image
      v-if="mode == 'comment'"
      key="avatar"
      class="avatar"
      fit="cover"
      :src="detail.user.avatar"
    >
    </el-image>
    <div class="commentMain">
      <span class="name_content">
        <span class="name" @click="goHomePage(detail.user.id)">{{
          detail.user.display_name
        }}</span>
        <template v-if="mode == 'reply'">
          {{l("回复")}}
          <span class="name" @click="goHomePage(detail.to_user.id)">
            {{ detail.to_user.display_name }}
          </span>
        </template>
        ：{{ detail.content }}
      </span>

      <div class="operationPanel">
        <div class="time">{{ detail.created_time.slice(5) }}</div>

        <div
          v-show="detail.user.id == $store.state.session.user.id"
          class="operation hide_operation"
          @click="off"
        >
          <i class="el-icon-delete" style="font-size: 16px"></i>
          <div class="count">{{l("删除")}}</div>
        </div>

        <div
          v-show="detail.user.id != $store.state.session.user.id"
          class="operation hide_operation"
          @click="accusation(detail)"
        >
          <i class="el-icon-warning-outline" style="font-size: 16px"></i>
          <div class="count">{{l("举报")}}</div>
        </div>

        <div class="operation" @click="clickReply">
          <el-image
            fit="cover"
            :src="GetResourceUrl('forum/icon-comments.svg')"
          >
          </el-image>
          <div class="count">{{l("回复")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForumComment",
  props: {
    detail: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: "comment", //comment reply
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    clickReply() {
      this.$emit("click_reply", this.detail);
    },
    off() {
      this.$confirm(this.l("是否确认删除") + "？", "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/forum/my_discuss/${this.detail.id}/off/`)
          .then(() => {
            this.$emit("refresh_list");
          });
      });
    },
    goHomePage(user_id) {
      if (!user_id) return;
      this.$router.push("/home/forum/?tab=post&user_id=" + user_id);
    },
    accusation(detail) {
      this.$prompt(this.l("请填写举报原因"), this.l("举报"), {
        confirmButtonText: this.l("确定"),
        cancelButtonText: this.l("取消"),
        inputPattern: /\S/,
        inputErrorMessage: this.l("请填写举报原因"),
      }).then(({ value }) => {
        this.axios.post(`/api/user_accusation/`, {
          record_sign: detail.id,
          module: "accusation",
          comment: this.l("举报论坛评论") + "：" + value,
        });
      });
    },
  },
};
</script>


<style scoped lang="scss">
.commentItem {
  padding-top: 8px;
  margin-bottom: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;

  &.replyItem {
    .commentMain {
      margin-left: 44px;
    }
  }

  .avatar {
    width: 34px;
    height: 34px;
    margin-right: 10px;
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 50%;
  }
  .commentMain {
    flex-grow: 1;
    .name_content {
      line-height: 20px;
      font-size: 12px;
      .name {
        cursor: pointer;
        color: $warningColor;
      }
    }

    .hide_operation {
      visibility: hidden;
    }
    &:hover {
      .hide_operation {
        visibility: inherit;
      }
    }
  }
}

.operationPanel {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 22px;
  .time {
    color: #999;
    margin-right: auto;
    font-size: 12px;
  }
  .operation {
    display: flex;
    color: #999;
    cursor: pointer;
    margin-left: 20px;
    .el-image {
      width: 16px;
      height: 16px;
    }
    .count {
      font-size: 12px;
      margin-left: 8px;
    }
  }
}
</style>

